import { useEffect } from 'react'
import { useConnect } from 'wagmi'
import { InjectedConnector } from 'wagmi/connectors/injected'

import { useIsConnected } from '../../state/application/hooks'
// import { useWalletState } from './useWalletState'
import useActiveWeb3React from './useActiveWeb3React'

/**
 * Use for network and injected - logs user in
 * and out after checking what network theyre on
 * @param {boolean} suppress
 */
export default function useInactiveListener(suppress = false) {
  const { connect /* , pendingConnector*/ } = useConnect({
    connector: new InjectedConnector(),
  })

  const [isAllowedConnect] = useIsConnected()

  const { isConnected, chainId } = useActiveWeb3React() /* useWalletState(
    !!pendingConnector)*/

  useEffect(() => {
    const { ethereum } = window
    if (ethereum && ethereum.on && !isConnected && !suppress && isAllowedConnect) {
      const handleChainChanged = () => {
        try {
          connect()
        } catch (e) {
          return
        }
      }

      const handleAccountsChanged = (accounts: string[]) => {
        if (accounts.length > 0) {
          try {
            connect()
          } catch (e) {
            return
          }
        }
      }
      ethereum.on('chainChanged', handleChainChanged)
      ethereum.on('accountsChanged', handleAccountsChanged)

      return () => {
        if (ethereum.removeListener) {
          ethereum.removeListener('chainChanged', handleChainChanged)
          ethereum.removeListener('accountsChanged', handleAccountsChanged)
        }
      }
    }
    return undefined
  }, [chainId, connect, isAllowedConnect, isConnected, suppress])
}
